import React, { Component } from 'react'
import ResourceItem from '../../models/resourceItem'
import ReactAudioPlayer from 'react-audio-player';
interface iProps {
    extraProps: ResourceItem,
    eventTrackingReport?: (resource_id: string, watch_at: number, look_time: number) => void
}
interface iState {
    playStartTime: number // 本次音频开始播放的时间
}
let audioInterval = null // 观看音频定时器
export default class clazzAudio extends Component<iProps, iState> {
    state: iState = {
        playStartTime: null
    }
    // 音频开始播放
    audioPlay = () => {
        console.log('音频开始播放')
        let that = this
        let {extraProps} = this.props
        this.setState({playStartTime: (+new Date())})
        audioInterval = setInterval(() => {
            that.props.eventTrackingReport(extraProps?.id,this.state.playStartTime, 10)
        }, 10000)
    }
    // 音频开始播放
    audioPause = () => {
        console.log('音频暂停播放')
        audioInterval && clearInterval(audioInterval)
    }
    componentWillUnmount () {
        audioInterval && clearInterval(audioInterval)
    }
    componentDidMount () {
    }
    render() {
        let {extraProps} = this.props
        return (
            <div className="clazzAudio">
                <div className="clazzAudio_play">
                    <div className="clazzAudio_play_title">{extraProps?.title}</div>
                    <ReactAudioPlayer
                        src={extraProps?.playUrl}
                        onPlay={this.audioPlay}
                        onPause={this.audioPause}
                        controls
                        // onContextMenu={(e) => e.preventDefault()}
                        // controlslist="noplaybackrate nodownload"
                    />
                </div>
            </div>
        )
    }
}
